import React from 'react';

import { formatDate } from 'lib/helpers/dateUtils';
import { cn } from 'lib/helpers/utility';
import useTimezone from 'lib/hooks/useTimezone';

import Button from '../Button/Button';
import Popover from '../Popovers/Popover/Popover';

import DateRangeContent from './components/DateRangeContent';
import { getOptionsByDirection } from './lib/helpers';

export { default as DateRangeContent } from './components/DateRangeContent';
export {
  getDateRange,
  getDateRangeByUnit,
  getDateOptions,
  getFutureDateOptions,
  getAllDateOptions
} from './lib/helpers';

const DateRangeSelector = ({
  onChange,
  value,
  buttonClassName,
  buttonTextClassName,
  buttonIcon,
  buttonIconColor = 'neutral',
  position,
  direction
}) => {
  const timezone = useTimezone();
  const options = getOptionsByDirection(direction, timezone);

  const buttonText =
    value?.id !== 'custom-date-range' ? (
      options.find((option) => option.id === value?.id)?.label || value?.label || 'All Time'
    ) : (
      <>
        <label className={cn('cursor-pointer', buttonTextClassName || 'text-neutral-800')}>
          {formatDate(value?.startDate, timezone)}
        </label>
        <span className={cn('cursor-pointer', buttonTextClassName || 'text-neutral-800')}>-</span>
        <label className={cn('cursor-pointer', buttonTextClassName || 'text-neutral-800')}>
          {formatDate(value?.endDate, timezone)}
        </label>
      </>
    );

  return (
    <Popover
      panelClassName="p-0 min-w-[244px] w-fit"
      position={position}
      isFixed
      customButtonTrigger={({ open }) => (
        <Button
          variant="tertiary"
          size="xs"
          text={buttonText}
          icon={buttonIcon}
          className={cn('whitespace-nowrap', open && 'bg-neutral-100', buttonClassName)}
          textClassName={buttonTextClassName}
          iconColor={buttonIconColor}
        />
      )}>
      {({ closePopover }) => (
        <DateRangeContent
          onChange={onChange}
          value={value}
          onClose={closePopover}
          direction={direction}
        />
      )}
    </Popover>
  );
};

export default DateRangeSelector;
